import React from "react";
import {
  DeleteTagTypesMutation,
  RestoreTagTypesMutation,
  TagTypesListQuery,
  type TagTypesListRow,
} from "@/admin/entities/tagTypes";
import { InnerCRUD } from "@/shared/components";
import {
  getTableData,
  mapColumns,
  getColumnsConfig,
  getTextsConfig,
} from "./config";
import { createSchema, editSchema } from "./schemas";

interface OrganizationTagTypesProps {
  id?: string;
}

/**
 * InnerCRUD компонент для управления типами тегов организации
 * Используется как таб внутри редактирования организации
 */
export const OrganizationTagTypes: React.FC<OrganizationTagTypesProps> = ({
  id,
}) => {
  return (
    <InnerCRUD<TagTypesListRow>
      listQuery={TagTypesListQuery}
      listQueryVariables={{ filter: { organizationId: id } }}
      getTableData={getTableData}
      mapColumns={mapColumns}
      columns={getColumnsConfig()}
      createSchema={createSchema}
      createMutationVariables={() => ({
        input: {
          organizationId: id,
        },
      })}
      editSchema={editSchema}
      deleteMutation={DeleteTagTypesMutation}
      restoreMutation={RestoreTagTypesMutation}
      texts={getTextsConfig()}
    />
  );
};
